import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';
import AppSideCart from './AppSideCart.tsx';
import AppCheckout from './AppCheckout';

const renderApp = (elementId: string, Component: React.FC) => {
  const element = document.getElementById(elementId);
  if (element) {
    ReactDOM.render(
      <React.StrictMode>
        <BrowserRouter>
          <Component />
        </BrowserRouter>
      </React.StrictMode>,
      element
    );
  }
};

// Rendering spezifischer Komponenten
renderApp('zoya', AppCheckout);
renderApp('yoza', AppSideCart);

serviceWorker.unregister();
reportWebVitals();